import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=89fb8774&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=89fb8774&scoped=true&lang=css&"
import style1 from "@/assets/css/font.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/content.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fb8774",
  null
  
)

export default component.exports